import './RequestsBrowser.scss';
import { prefixClass } from 'lib/utils';
import AssignmentGroup from '../AssignmentGroup';

import { FilterProps } from '../utils/filterAndSearchUtils';
import { useRef, useEffect } from 'react';
import RBSearch from './RBSearch';
import RBFilter from './RBFilter';
import { useQueueContext } from '../QueueContext';

const RequestsBrowser = () => {
  const prefix = prefixClass('requests-browser');
  const resultsRef = useRef<HTMLDivElement>(null);
  const {
    state: { filters, requests, splitRequests, priorityGroups, newRequestAdded },
    dispatch,
  } = useQueueContext();

  const handleSearch = (value: string) => {
    dispatch({
      type: 'SET_FILTERS',
      payload: { ...filters, search: value },
    });
  };
  const handleClear = () => {
    dispatch({
      type: 'SET_FILTERS',
      payload: { ...filters, search: '' },
    });
  };

  const updateFilters = (newFilter: string) => {
    dispatch({ type: 'SET_FILTERS', payload: { ...filters, sort: newFilter } as FilterProps });
  };

  const handleRequestClick = (requestId: string) => {
    const request = requests.find(r => r.id === requestId);
    if (request) {
      dispatch({ type: 'SET_SELECTED_ITEM', payload: request });
    }
  };

  // Effect to scroll to bottom when a new request is added and we're in oldest-first mode
  useEffect(() => {
    if (newRequestAdded && filters.sort === 'oldest' && resultsRef.current) {
      // Delay the scroll to ensure the DOM has been updated
      setTimeout(() => {
        if (resultsRef.current) {
          resultsRef.current.scrollTop = resultsRef.current.scrollHeight;
        }

        // Reset the newRequestAdded flag so we don't scroll again on subsequent renders
        dispatch({ type: 'SET_NEW_REQUEST_ADDED', payload: null });
      }, 500);
    }
  }, [newRequestAdded, filters.sort]);

  return (
    <div className={prefix()}>
      <RBSearch searchValue={filters.search || ''} onSearch={handleSearch} onClear={handleClear} />
      <RBFilter filter={filters} onFilterChange={updateFilters} />
      {/* AssignmentGroups by priority */}
      <div ref={resultsRef} className={prefix('results')}>
        {/* We don't have assignment in the API once that's implemented we can now bring this ones back */}
        {/*<AssignmentGroup*/}
        {/*  me*/}
        {/*  requests={splitRequests?.me || []}*/}
        {/*  reversed={filters.sort === 'newest'}*/}
        {/*  onClick={handleRequestClick}*/}
        {/*/>*/}
        <AssignmentGroup
          me={false}
          blocker
          requests={priorityGroups.Blocker}
          reversed={filters.sort === 'newest'}
          onClick={handleRequestClick}
        />
        <AssignmentGroup
          me={false}
          requests={priorityGroups.Normal}
          reversed={filters.sort === 'newest'}
          onClick={handleRequestClick}
        />
      </div>
    </div>
  );
};

export default RequestsBrowser;
